/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import Box from "components/generals/Box";
import FacilityTable from "components/tables/FacilityTable";
import { CoreAPI_URLs } from "constants/http.const";
import useHttp from "hooks/http.hook";
import useSort from "hooks/useSort.hook";
import { FacilityInterface, QueryResultInterface } from "@malmur-technologies/medicalsystem-shared";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

/**
 * Content component for displaying and managing medical facilities.
 * Provides a table view of all facilities with search, filtering, and pagination functionality.
 * @returns {React.ReactElement} The facility data content component
 */
const FacilityDataContent: React.FC = () => {
  const [isLoading, _error, sendRequest] = useHttp();
  const [facilityList, setFacilityList] = useState<FacilityInterface[]>([]);
  const [page, setPage] = useState<number>(1);
  const [pageTotal, setPageTotal] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [rowsTotal, setRowsTotal] = useState<number>(0);
  const { t } = useTranslation();
  const [filterModel, setFilterModel] = useState<string>("");
  const { sortBy, sortOrder, handleSortChange, buildSortParam } = useSort();

  useEffect(() => {
    console.log("sending request...");
    const nameParam = filterModel ? `name=${filterModel}&` : "";
    const url = `${CoreAPI_URLs.FACILITY_GET_ALL}?${nameParam}${buildSortParam()}page=${page}&pageSize=${pageSize}`;

    sendRequest(url, onGetFacilityHandler, "GET");
  }, [page, pageSize, filterModel, buildSortParam]);
  const onGetFacilityHandler = (facilitysResponse: QueryResultInterface<FacilityInterface>) => {
    setFacilityList(facilitysResponse.results);
    setRowsTotal(facilitysResponse.total);
    setPageTotal(Math.ceil(facilitysResponse.total / pageSize));
  };

  return (
    <Box>
      <FacilityTable
        modelList={facilityList}
        setModelList={setFacilityList}
        canSearchPlaceholder={t("facilityTable.searchFacility")}
        entriesPerPage={{ defaultValue: pageSize }}
        setPageState={setPage}
        setPageSizeState={setPageSize}
        apiPagination={true}
        apiPageTotal={pageTotal}
        apiRowsTotal={rowsTotal}
        apiPageCurrentIndex={page}
        setModelFilter={setFilterModel}
        isLoading={isLoading}
        onSortChange={handleSortChange}
        currentSortBy={sortBy}
        currentSortOrder={sortOrder}
      />
    </Box>
  );
};

export default FacilityDataContent;
